import { jsx as t } from "react/jsx-runtime";
import { InputField as l } from "./index.es37.js";
import { NumericField as a } from "./index.es42.js";
const m = ({ gridDensity: r }) => {
  const o = () => r === "compact" ? "small" : r === "comfort" ? "large" : "default";
  return {
    agNumberCellEditor: (e) => /* @__PURE__ */ t(
      a,
      {
        size: o(),
        value: e.value,
        onChange: e.onValueChange
      }
    ),
    agCellEditor: (e) => /* @__PURE__ */ t(
      l,
      {
        disableCloseIcon: !0,
        size: o(),
        value: e.value,
        onChange: e.onValueChange
      }
    )
  };
};
export {
  m as getOverrideTableComponents
};
//# sourceMappingURL=index.es535.js.map
